import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallback,
});

function AuthCallback() {
  const navigate = useNavigate();
  const searchParams = Route.useSearch();
  const { refetchUser } = useAuth();

  useEffect(() => {
    handleCallback();
  }, []);

  async function handleCallback() {
    const { code, state } = searchParams as { code?: string; state?: string };

    if (!code || !state) {
      console.error("Missing code or state parameter");
      navigate({ to: "/" });
      return;
    }

    // Exchange code for tokens (server will validate state and retrieve PKCE)
    const response = await fetch("/auth/exchange", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        code,
        state,
        redirectURI: `${window.location.origin}/auth/callback`,
      }),
    });

    if (response.ok) {
      // Refetch user data now that cookies are set
      await refetchUser();
      navigate({ to: "/" });
    } else {
      console.error("Token exchange failed");
      navigate({ to: "/" });
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p>Completing login...</p>
    </div>
  );
}
